/* Quantity-break synchronization for the canonical Shopify product + variant.
 * Does NOT construct multipack product IDs or bypass Bundler/Shopify discounts.
 */
(() => {
  'use strict';
  const roots=new WeakSet();
  function init(root){
    if(!(root instanceof HTMLElement)||roots.has(root))return;
    roots.add(root);
    const form=root.querySelector('form[action*="/cart/add"]')||root.querySelector('form');
    const quantityInput=form?.querySelector('[data-zyma-bundler-form-quantity]');
    const variantInput=form?.querySelector('[data-zyma-pd-variant]');
    const section=root.closest('[data-zyma-pd],[data-zyma-pdp]')||root;
    if(!form||!quantityInput||!variantInput)return;
    const getSelected=()=>{
      // Bundler's actual offer selection uses _bndlr_radio_* radios.
      // Each row also contains bundle_quantity, which supplies the unit count.
      const checked=root.querySelector('input[type="radio"][name^="_bndlr_radio_"]:checked,input[type="radio"][id^="_bndlr_radio_"]:checked');
      const row=checked?.closest('.bndlr-radio-container')
        || root.querySelector('.bndlr-radio-container.is-selected,.bndlr-radio-container.selected');
      if(!row)return null;
      const source=row.querySelector('[name="bundle_quantity"]');
      const parsed=Number(source?.value||row.dataset.bundleQuantity||'');
      return Number.isInteger(parsed)&&parsed>=1&&parsed<=50 ? {quantity:parsed,row} : null;
    };
    const announce=(qty,row)=>{
      const language=document.documentElement.lang.startsWith('ar');
      const label=language?(qty===1?'عبوة واحدة':qty===2?'عبوتين':qty+' عبوات'):(qty+' '+(qty===1?'pack':'packs'));
      const detail={units:qty,label,available:!root.querySelector('[ref="addToCartButton"]')?.disabled,variantId:variantInput.value};
      section.dispatchEvent(new CustomEvent('zyma:purchase-change',{detail,bubbles:true}));
      section.querySelectorAll('[data-zyma-pd-selection-label],[data-zyma-sticky-selection]').forEach(x=>{x.textContent=label;});
      section.querySelectorAll('[data-zyma-pd-bar-submit],[data-zyma-sticky-submit]').forEach(btn=>{
        if(!(btn instanceof HTMLButtonElement))return;
        if(!btn.dataset.zymaBaseLabel)btn.dataset.zymaBaseLabel=btn.textContent?.trim()||'';
        const text=qty===1?btn.dataset.zymaBaseLabel:(language?'ضيف '+label:'Add '+label);
        btn.textContent=text;
        btn.setAttribute('aria-label',language?'ضيف '+label+' للسلة':'Add '+label+' to bag');
      });
      const offerPrice=row?.querySelector('.bndlr-discounted-price')?.textContent?.trim() || '';
      const stickyPrices=section.querySelectorAll('.zyma-pd-bar__price,.zp-sticky-purchase__price');
      stickyPrices.forEach(el=>{
        if(!(el instanceof HTMLElement))return;
        if(!el.dataset.zymaSinglePrice)el.dataset.zymaSinglePrice=el.textContent||'';
        if(!el.dataset.zymaUnitLabel)el.dataset.zymaUnitLabel=el.getAttribute('data-unit-label')||' ';
        if(qty>1){
          el.textContent=offerPrice || (language?'السعر حسب العرض المختار':'Selected offer price above');
          el.removeAttribute('data-unit-label');
          el.setAttribute('data-zyma-price-mode','offer');
        }else{
          el.textContent=el.dataset.zymaSinglePrice;
          el.setAttribute('data-unit-label',el.dataset.zymaUnitLabel.trim());
          el.removeAttribute('data-zyma-price-mode');
        }
      });
    };
    let current=null;
    const syncQty=()=>{
      const selected=getSelected();
      // Bundler is authoritative for the radio choice; respect a legitimate variant
      // change instead of restoring the original variant behind the customer's back.
      const existing=Number(quantityInput.value);
      const qty=selected?.quantity||((Number.isInteger(existing)&&existing>=1&&existing<=50)?existing:1);
      if(quantityInput.value!==String(qty))quantityInput.value=String(qty);
      const signature=qty+'|'+(selected?.row.querySelector('.bndlr-discounted-price')?.textContent?.trim()||'')+'|'+variantInput.value;
      if(current!==signature){current=signature;announce(qty,selected?.row);}
      return qty;
    };
    form.addEventListener('submit',()=>{syncQty();},{capture:true});
    root.addEventListener('change',event=>{
      if(event.target instanceof HTMLInputElement&&(event.target.name==='bundle_quantity'||event.target.name.startsWith('_bndlr_radio_'))){syncQty();requestAnimationFrame(syncQty);}
    });
    root.addEventListener('click',event=>{
      if(event.target instanceof Element&&event.target.closest('.bndlr-radio-container')){queueMicrotask(syncQty);requestAnimationFrame(syncQty);}
    });
    let task=false;
    new MutationObserver(()=>{
      if(task)return;task=true;
      queueMicrotask(()=>{task=false;syncQty();});
    }).observe(root,{childList:true,characterData:true,subtree:true,attributes:true,attributeFilter:['checked','class','data-bundler-break-active']});
    syncQty();
    // A lazy/async Bundler mount can appear after the product form is ready.
    // Periodically reconcile selection while the page is open; no cart network calls.
    let passes=0;
    const timer=setInterval(()=>{
      if(!root.isConnected||passes++>=24){clearInterval(timer);return;}
      syncQty();
    },500);
  }
  function all(scope=document){scope.querySelectorAll?.('[data-zyma-bundler-native]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>all(),{once:true});else all();
  document.addEventListener('shopify:section:load',event=>all(event.target));
})();
